<template>
  <section class="testimonials" v-if="randomTestimonial">
    <div class="inner">
      <p class="quote">
        <font-awesome-icon icon="quote-left" />{{ randomTestimonial.quote }}<font-awesome-icon icon="quote-right" />
      </p>
      <p class="label">
        {{ randomTestimonial.name }} <strong>{{ randomTestimonial.area }}</strong>
      </p>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"

export default {
  computed: {
    ...mapState(["misc"]),
    randomTestimonial() {
      if (this.misc && this.misc.testimonials && this.misc.testimonials.length)
        return this.misc.testimonials[Math.floor(Math.random() * this.misc.testimonials.length)]

      return null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.testimonials {
  text-align: center;
  padding: 4rem 0;
  line-height: 1.8;
  background: #455c6e;
  color: white;
}

p.quote {
  max-width: 1000px;
  margin: auto;
  font-size: 3rem;
}

.quote svg {
  color: #d1ae54;
  font-size: 2rem;
  margin: 0 2rem;
  vertical-align: text-top;
}

.label {
  color: #d1ae54;
}

.label strong {
  color: white;
  font-weight: normal;
}

@media screen and (max-width: 750px) {
  p.quote {
    font-size: 2.5rem;
  }
}
</style>
